// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
// EntityType identifies the type of content to be classified.
export var EntityType;
(function (EntityType) {
    EntityType["ENTITY_TYPE_UNSPECIFIED"] = "ENTITY_TYPE_UNSPECIFIED";
    EntityType["ENTITY_TYPE_SMS"] = "ENTITY_TYPE_SMS";
    EntityType["ENTITY_TYPE_FAX"] = "ENTITY_TYPE_FAX";
    EntityType["ENTITY_TYPE_EMAIL"] = "ENTITY_TYPE_EMAIL";
})(EntityType || (EntityType = {}));
export var EntityType_index;
(function (EntityType_index) {
    EntityType_index[EntityType_index["ENTITY_TYPE_UNSPECIFIED"] = 0] = "ENTITY_TYPE_UNSPECIFIED";
    EntityType_index[EntityType_index["ENTITY_TYPE_SMS"] = 1] = "ENTITY_TYPE_SMS";
    EntityType_index[EntityType_index["ENTITY_TYPE_FAX"] = 2] = "ENTITY_TYPE_FAX";
    EntityType_index[EntityType_index["ENTITY_TYPE_EMAIL"] = 3] = "ENTITY_TYPE_EMAIL";
})(EntityType_index || (EntityType_index = {}));
